export default class NativeBridge {
  constructor() {
    this.responseResultFnMap = {}
    this.globalAppResponse = null //全局接收app消息
  }


  sendMessage(method, data = {}, sync = true) {
    return new Promise((resolve, reject) => {
      const params = JSON.stringify(data)
      // console.log('调用了方法 =》' + method);
      if (window.webkit) {
      // if (window.webkit && window.webkit.messageHandlers[method]) {
        // window.webkit.messageHandlers[method].postMessage(params)
        // eslint-disable-next-line no-undef
        MostOneJSApis[method](params)
      } else {
        try {
          if (params === '{}') {
            // eslint-disable-next-line no-undef
            MostOneJSApis[method]()
          } else {
            // eslint-disable-next-line no-undef
            MostOneJSApis[method](params)
          }
        } catch (e) {
          // console.log(`请求方法:${method}不存在`)
          reject('请求方法不存在')
        }
      }
      if (!sync) resolve(); //自定义接收消息的话用异步接收
      else this.receiveMessage(method, resolve)
    })
  }

  receiveMessage(method, resolve) {
    this.responseResultFnMap[method] = resolve
    const responseResultFn = (res) => {
      try {
        const result = JSON.parse(res)
        console.log('返回值=》', result);
        this.globalAppResponse && this.globalAppResponse(result);
        if (this.responseResultFnMap[result.methods]) {
          this.responseResultFnMap[result.methods](result)
          delete this.responseResultFnMap[result.methods]
        }
      } catch (e) {
        console.log('响应解析错误')
      }
    }
    window.appCallbackResult = responseResultFn
  }

  setGlobalAppResponse(callback) {
    this.globalAppResponse = callback;
  }

}
